var map = {
	"./baac.svg": 936,
	"./bay.svg": 937,
	"./bbl.svg": 938,
	"./bnp.svg": 939,
	"./boa.svg": 940,
	"./cacib.svg": 941,
	"./cimb.svg": 942,
	"./citi.svg": 943,
	"./db.svg": 944,
	"./ghb.svg": 945,
	"./gsb.svg": 946,
	"./hsbc.svg": 947,
	"./ibank.svg": 948,
	"./icbc.svg": 949,
	"./jpm.svg": 950,
	"./kbank.svg": 340,
	"./kk.svg": 951,
	"./ktb.svg": 952,
	"./lhb.svg": 953,
	"./mb.svg": 954,
	"./mega.svg": 955,
	"./mufg.svg": 956,
	"./rbs.svg": 957,
	"./sc.svg": 958,
	"./scb.svg": 959,
	"./smbc.svg": 960,
	"./tbank.svg": 961,
	"./tcrb.svg": 962,
	"./tisco.svg": 963,
	"./tmb.svg": 964,
	"./ttb.svg": 965,
	"./uob.svg": 341
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 104
// module chunks = 1